type numberConversion = (totalMinutes: number) => string;

const convertMinutesToHoursAndMinutes: numberConversion = (totalMinutes: number) => {
  const hours = Math.floor(totalMinutes / 60);
  const minutes = totalMinutes % 60;
  return `${hours}h ${minutes}min`;
};

const filterJobs = (data:any, jobTitle:any) => {
  const uniqueIds = new Set();
  return data?.reduce((acc:any, item:any) => {
    if (item?.job === jobTitle && !uniqueIds?.has(item.id)) {
      uniqueIds?.add(item.id);
      acc?.push(item);
    }
    return acc;
  }, []);
};

export { convertMinutesToHoursAndMinutes,filterJobs };
